var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import * as Popover from '@radix-ui/react-popover';
import * as Carousel from 'root/src/client/v2/common/components/Carousel/Carousel';
import { twMerge } from 'tailwind-merge';
export const SelectSlider = (props) => {
    const { label, options, onChange, value, className } = props, rest = __rest(props, ["label", "options", "onChange", "value", "className"]);
    return (<Popover.Root>
			<Popover.Trigger asChild>
				<button className="bg-white rounded w-24 py-1 group items-center flex text-dark-2 self-center justify-center uppercase text-sm relative" type="button">
					{label}
					<span className="flex flex-initial text-dark-2 text-[0.4rem] absolute origin-center motion-safe:duration-150 right-2 group-data-[state=open]:rotate-180">&#9660;</span>
				</button>
			</Popover.Trigger>
			<Popover.Portal>
				<Popover.Content className="z-[10000] shadow-2xl drop-shadow-2xl motion-safe:data-[state=open]:animate-slide-down" sideOffset={5} collisionPadding={10}>
					<div className="bg-white overflow-hidden">
						<Carousel.Root axis="y" dragFree>
							<Carousel.Container className={twMerge('flex flex-col w-36 sm:w-24 h-36 divide-y divide-black px-1', className)} {...rest}>
								{options.map((option) => {
            return (<Popover.Close key={option.label} asChild>
											<OptionButton aria-disabled={option.isDisabled} data-selected={value === option.value} onClick={(event) => {
                    if (option.isDisabled) {
                        event.preventDefault();
                        return;
                    }
                    onChange(option.value);
                }}>
												{option.label}
											</OptionButton>
										</Popover.Close>);
        })}
							</Carousel.Container>
						</Carousel.Root>
					</div>
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>);
};
const OptionButton = memo((props) => {
    return (<button type="button" className="text-black p-2 text-sm motion-safe:duration-150 data-[selected=true]:font-bold tabular-nums bg-white aria-disabled:opacity-10 aria-disabled:cursor-not-allowed" {...props}/>);
});
